import { HttpService } from '../http.service';
import reducer, { InitSchemaReducer } from '../../decorators/reducer.decorator';
import { Entities } from '../../store/entities/entities.enum';
import { DIContainerKeys } from '../../di-container/di-container.keys';
import UserReducer from '../../../redux/userState/reducer';
import action from '../../decorators/action.decorator';
import { call, put } from 'redux-saga/effects';
import AuthUserMethods from '../../store/auth-user/auth-user.methods';
import flagger from '../../decorators/flagger.decorator';
import { Flaggers } from '../../store/flaggers/flaggers.enum';
import { IP_API_URL } from '../../../constants/apis.constants';
import type LoginTokenDto from './dto/login-token.dto';
import type CheckGoogleAuthDto from './dto/check-google-auth.dto';
import type ConfirmGooglePinDto from './dto/confirm-google-pin.dto';

export const AuthUserEffectActions = {
  setUserObjectData: `${Entities.AuthUser}_setUserObjectData`,
  loginToken: `${Entities.AuthUser}_loginToken`,
  checkGoogleAuth: `${Entities.AuthUser}_checkGoogleAuth`,
  confirmGooglePin: `${Entities.AuthUser}_confirmGooglePin`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.AuthUser,
  reducerFunc: UserReducer,
  initSchema,
  aliasName: DIContainerKeys.AuthService,
})
export class AuthService extends HttpService {
  @flagger(Flaggers.ExportClientReportFlagger)
  @action(DIContainerKeys.AuthService)
  public *setUserObjectData(payload: any) {
    yield put({
      type: AuthUserMethods.SET_USER_OBJECT_DATA,
      payload: {
        objectData: payload,
      },
    });
  }

  @flagger(Flaggers.LoginTokenFlagger)
  @action(DIContainerKeys.AuthService)
  public *loginToken(dto: LoginTokenDto): any {
    const getIP = async () => {
      const response = await fetch(IP_API_URL as string, {
        method: "GET",
      });
      return response.json();
    }
    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("grant_type", "password");
    urlencoded.append("username", dto?.username);
    urlencoded.append("password", dto?.password);
    const response = yield call(getIP);
    if (response && response?.ip) {
      urlencoded.append("ipaddress", response?.ip);
    } else {
      urlencoded.append("ipaddress", "127.0.0.1");
    }

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow" as RequestRedirect,
    };

    const login = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/ObjectraAPI/Token`,
        requestOptions
      )
      return response.json();
    }

    const loginResponse = yield call(login);

    yield this.setFlaggerState(Flaggers.LoginTokenFlagger, loginResponse);
  }

  @flagger(Flaggers.CheckGoogleAuthFlagger)
  @action(DIContainerKeys.AuthService)
  public *checkGoogleAuth(dto: CheckGoogleAuthDto): any {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${dto?.authToken}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow" as RequestRedirect,
    };
    const checkAuth = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/CC_API/CheckGoogleAuth`,
        requestOptions
      )
      return response.json();
    }
    const checkAuthResponse = yield call(checkAuth);
    yield this.setFlaggerState(Flaggers.CheckGoogleAuthFlagger, checkAuthResponse);
  }

  @flagger(Flaggers.ConfirmGooglePinFlagger)
  @action(DIContainerKeys.AuthService)
  public *confirmGooglePin(dto: ConfirmGooglePinDto): any {
    let myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${dto?.authToken}`);

    let requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow" as RequestRedirect,
    };
    const confirmPin = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/CC_API/ConfirmGooglePin?pin=${dto?.pin}`,
        requestOptions
      )
      return response.json();
    }
    const confirmPinResponse = yield call(confirmPin);
    yield this.setFlaggerState(Flaggers.ConfirmGooglePinFlagger, confirmPinResponse);
  }
}